<template>
  <div :class="sectionClasses">
    <Button
      v-for="(button, index) in buttonRow"
      :key="index"
      v-bind="{ buttonProps: button }"
      :class="{
        'flex-grow md:flex-grow-0': true,
      }"
    ></Button>
  </div>
</template>
<script lang="ts" setup>
import type { ButtonRow } from '~/sanity/types';
const props = defineProps<ButtonRow>();
const { alignment } = toRefs(props);
const sectionClasses = computed(() => ({
  'button-wrapper flex gap-3 items-center flex-wrap': true,
  [alignment.value ? alignmentClasses[alignment.value] : 'center']: true,
}));
const alignmentClasses: Record<string, string> = {
  left: 'text-left justify-start',
  center: 'text-center justify-center',
  right: 'text-right justify-end',
};
</script>

<style scoped></style>
